<section class="cz-ergo-eval-complete-evaluation-dialog-component">
  <mat-dialog-title class="mat-dialog-title">
    <div class="row">
      <div class="col-xs-10">
        <h3 class="title truncate" [innerHTML]="'$evaluation_completed_dialog_heading' | translate"></h3>
      </div>
      <div class="col-xs-2 end-xs">
        <button mat-button mat-dialog-close class="mat-dialog-back-button">
            <mat-icon>close</mat-icon>
        </button>
      </div>
    </div>
  </mat-dialog-title>
  <mat-dialog-content>
    <p [innerHTML]="'$evaluation_completed_dialog_text' | translate"></p>
    <div class="row bottom-buttons">
      <div class="col-xs-12 end-xs">
        <button mat-button mat-dialog-close [innerHTML]="'$btn_cancel' | translate"></button>
        <button mat-flat-button color="primary" mat-dialog-close (click)="completeEvaluation()" [innerHTML]="'$btn_save_and_complete_evaluation' | translate"></button>
      </div>
    </div>
  </mat-dialog-content>
</section>